module.exports = __webpack_public_path__ + "img/logo_rincontravel.ff41b549.png";